// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1HPFz","choiceBoxes":"toolbarselects_choiceBoxes__3vnmw","simpleField":"toolbarselects_simpleField__1QM8N"};